import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { FaRocket, FaLock } from "react-icons/fa";

const ComingSoonAssessment = ({ planName = "Premium" }) => {
  const { isAuthenticated, checkTokenValidity } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || !checkTokenValidity()) {
      navigate("/auth/signin");
      return;
    }
  }, [isAuthenticated, checkTokenValidity, navigate]);

  return (
    <div className="max-w-4xl mx-auto p-8 flex-1 font-['Archivo']">
      <div className="text-center py-20">
        <div className="mb-8">
          <FaLock className="mx-auto h-24 w-24 text-gray-400 mb-6" />
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {planName} Plan Coming Soon
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            We're working hard to bring you advanced risk assessment features. 
            This plan will include enhanced analytics, portfolio management, and enterprise-grade tools.
          </p>
        </div>
        
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 mb-8">
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">
            Be the first to know
          </h3>
          <p className="text-gray-700 mb-6">
            Join our waitlist to get early access and exclusive pricing when {planName} launches.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate("/products")}
              className="inline-flex items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors"
            >
              <FaRocket className="mr-2 h-5 w-5" />
              View All Plans
            </button>
            <button 
              onClick={() => navigate("/products/risk-assessment")}
              className="inline-flex items-center px-6 py-3 border border-gray-300 rounded-md shadow-sm text-base font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              Try Basic Plan
            </button>
          </div>
        </div>

        <div className="text-sm text-gray-500">
          <p>Questions? Contact us at support@smartriskassessment.com</p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonAssessment;